import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { HighGuideProductSignalSnapshot } from '../../../product/dto/product-signal/high-guide-product-signal-snapshot';

/**
 * One variant's company-level signal rollup, recalculated after a teammate reviewed it.
 *
 * Broadcast a few seconds behind the signal itself (`WebSocketReceiveHighGuideCompanySignalCreated`) and always
 * already including it, so the two are independent - neither payload needs the other and neither implies an order.
 * Delivery is at-least-once, so the same refreshed rollup can arrive twice; applying it again is a no-op.
 *
 * Only `payload.company` is populated. `global` and `previewRecommendations` come back `null`, meaning "unchanged"
 * rather than "empty" - the global rollup moves on its own schedule and the preview content rode along with the
 * signal event.
 */
export class WebSocketReceiveHighGuideCompanySignalSnapshot extends WebSocketReceiveMessage {
  override payload: HighGuideProductSignalSnapshot;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(HighGuideProductSignalSnapshot, this.payload);
  }
}
